@if (hasMultiLanguage) {
  <mulo-scrollable-toggle-group
    [buttonsKeys]="languages()"
    [buttonsKeysAriaLabels]="langLabels"
    [selectedButton]="selectedLanguage"
    [scrollLeftBtnAriaLabel]="'research.aria.multiLanguages.scroll.left' | translate"
    [scrollRightBtnAriaLabel]="'research.aria.multiLanguages.scroll.right' | translate"
    (selectedButtonChanged)="languageChange($event)"
    [canAdd]="canAdd()"
    >
  </mulo-scrollable-toggle-group>
  @if (languages()?.length > 0) {
    <button
      type="button"
      mat-icon-button
      [color]="color()"
      [disabled]="!selectedLanguage"
      (click)="removeLangComfirmation()"
        attr.aria-label="{{ 'research.aria.multiLanguages.remove' | translate }} {{
            'research.lang.' + selectedLanguage | translate
        }}"
      >
      <mat-icon svgIcon="delete"></mat-icon>
    </button>
  }
  <button
    type="button"
    aria-haspopup="listbox"
    #selectButton
    mat-button
    class="has-icon select-button"
    [color]="color()"
    [ngClass]="{ 'mat-icon-button': canAdd() && languages()?.length > 0 }"
    [disabled]="!canAdd() && languages()?.length > 0"
    [attr.aria-label]="'research.portal.multiLanguages.addLanguages.' + addLanguageLabel() | translate"
    (click)="select.open()"
    >
    <mat-icon svgIcon="plus"></mat-icon>
    @if (languages()?.length === 0) {
      <span>{{
        'research.portal.multiLanguages.addLanguages.' + addLanguageLabel() | translate
      }}</span>
    }
  </button>
}
<!-- style.display set to 'none' when panel close to prevent nested interactive elements which cause issues with screen readers -->
<mat-select
  [style.display]="select.panelOpen ? 'inline' : 'none'"
  #select
  [disabled]="!canAdd() && languages()?.length > 0"
  [disableOptionCentering]="true"
  (selectionChange)="addLanguage($event.value)"
  [panelClass]="'is-tall'"
  [aria-label]="'research.portal.multiLanguages.languages' | translate"
  (opened)="select.panel.nativeElement.scroll(0, 0)"
  >
  <mat-option>
    <ngx-mat-select-search
      [formControl]="langFilterCtrl"
      placeholderLabel="{{ 'research.assetype.lookup.placeholder' | translate }}"
      noEntriesFoundLabel="{{ 'research.portal.multiLanguages.lookup.no.match' | translate }}"
      ariaLabel="{{ 'research.aria.student.deposit.form.select.lookup' | translate : { value: 'languages' } }}"
      >
      <mat-icon ngxMatSelectSearchClear svgIcon="close"></mat-icon>
    </ngx-mat-select-search>
  </mat-option>
  @if ((multiLanguageService.preferredsLanguages$ | async | filterList : filterLanguage)?.length) {
    <mat-optgroup
      class="is-sticky"
      >
      <label>
        <span [muloElementAsHeading]="4" [innerHTML]="'preferred ' | highlight : langFilterCtrl.value"></span>
      </label>
      @for (lang of multiLanguageService.preferredsLanguages$ | async | filterList : filterLanguage; track lang) {
        <mat-option
          [disabled]="isLangExist(lang.value)"
          [value]="lang.value"
          >
          <span [innerHTML]="lang.code | translate | highlight : langFilterCtrl.value" class="semibold"></span>
          <span> · {{ lang.value | uppercase }} </span>
        </mat-option>
      }
    </mat-optgroup>
  }
  @if ((multiLanguageService.languages$ | async | filterList : filterLanguage)?.length) {
    <mat-optgroup
      class="is-sticky"
      >
      <label>
        <span [muloElementAsHeading]="4" [innerHTML]="'languages' | highlight : langFilterCtrl.value"></span>
      </label>
      @for (lang of multiLanguageService.languages$ | async | filterList : filterLanguage; track lang) {
        <mat-option
          [disabled]="isLangExist(lang.value)"
          [value]="lang.value"
          >
          <span [innerHTML]="lang.code | translate | highlight : langFilterCtrl.value" class="semibold"></span>
          <span> · {{ lang.value | uppercase }} </span>
        </mat-option>
      }
    </mat-optgroup>
  }
</mat-select>
